export enum ETrafficTypes {
  BANNER = 'banner',
  NATIVE = 'native',
  PUSH = 'push',
}

export enum EValidations {
  required = 'required',
  maxStringLength = 'maxStringLength',
  url = 'url',
}

export enum ECreativeFormFields {
  url = 'url',
  title = 'title',
  description = 'description',
  cta = 'cta',
}
  
export enum ELanguages {
  ru = 'RU',
  en = 'EN'
}

export enum ECurrencies {
  usd = 'USD',
  eur = 'EUR',
  rub = 'RUB'
}
